import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorld = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				className: "a",
				cx: 12,
				cy: 12,
				fill: "none",
				stroke: "currentColor",
				r: 11.25
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "a",
				d: "M9.289,22.921C7.767,20.689,6.75,16.633,6.75,12S7.767,3.311,9.289,1.079",
				fill: "none",
				stroke: "currentColor"
			}),
			/* @__PURE__ */ _jsx("line", {
				className: "a",
				x1: .75,
				y1: 12,
				x2: 23.25,
				y2: 12
			}),
			/* @__PURE__ */ _jsx("line", {
				className: "a",
				x1: 2.482,
				y1: 18,
				x2: 21.518,
				y2: 18
			}),
			/* @__PURE__ */ _jsx("line", {
				className: "a",
				x1: 2.482,
				y1: 6,
				x2: 21.518,
				y2: 6
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "a",
				d: "M14.711,1.079C16.233,3.311,17.25,7.367,17.25,12s-1.017,8.689-2.539,10.921",
				fill: "none",
				stroke: "currentColor"
			})
		]
	})
});
export default SvgWorld;
